import { render, staticRenderFns } from "./NewOrderRecevieModal.vue?vue&type=template&id=123ad02d"
import script from "./NewOrderRecevieModal.vue?vue&type=script&lang=js"
export * from "./NewOrderRecevieModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports